(function () {
	window.js = window.js || {};
	js.whatwedo = (function () {
		function initialize(domElm) {

			/* Target IE10 and IE11 to animate transform on SVG */
			bIE10 = !!Function('/*@cc_on return document.documentMode===10@*/')();
			bIE11 = !!window.MSInputMethodContext && !!document.documentMode;

			var aFill = document.querySelector('[data-step="step2a"]'),
				fill = aFill.querySelectorAll('.whatwedo__tofillup'),
				nFill = fill.length;

			if(bIE11 || bIE10) {
				aFill.addEventListener('mouseenter', function() {
					var i = nFill;
					while(i--) {
						fill[i].setAttribute('transform', "translate(0, -15)");
						fill[i].style.transition = 'transform .5s';
						fill[i].style.fontSize = '2.2em';
					} 
				});
				aFill.addEventListener('mouseleave', function() {
					var i = nFill;
					while(i--) {
						fill[i].removeAttribute('transform');
						fill[i].style.fontSize = '1em';
					}
				});
			}
			/* End of IE animations */

			/* Animation on items and active states */
			var toScroll = document.querySelector('.whatwedo').getBoundingClientRect().top;
			var aElm = document.querySelectorAll('.whatwedo__item');
			var nElm = aElm.length;

			var aDest = document.querySelectorAll('.whatwedo__process-item');
			var nArr = aDest.length;
			var nDest;


			// Array of items
			var aTarget = ['step1','step2a','step2b','step3'];
			var nTarget = aTarget.length;


			/* Add active state from home page to services page */
			for(var i=0; i<nTarget; i++) {
				if(window.location.href.indexOf(aTarget[i]) > -1) {
					document.querySelector('.whatwedo__item[data-step="'+aTarget[i]+'"]').classList.add('js-active');
			        document.querySelector('.whatwedo__process-item[data-step="'+aTarget[i]+'"]').classList.add('js-active');
			        window.scrollTo(0,toScroll);
			    }	
			}

			/* Click event to add js-active on the item selected and show text below */
			var thisDest;
			while(nElm--) {
				aElm[nElm].addEventListener('click',function(e){
					e.preventDefault();

					for(var i = 0; i < nArr; i++) {
						aDest[i].classList.remove('js-active');
						aElm[i].classList.remove('js-active');
					}

					this.classList.add('js-active');
					nDest = this.getAttribute('data-step');

					thisDest = document.querySelector('.whatwedo__process-item[data-step="'+nDest+'"]');
					thisDest.classList.add('js-active');
				});	
			}


		}

		return {
			initialize: initialize
		};

	})();
})();